import {useLingui} from '@lingui/react/macro';
import {useCallback} from 'react';
import {useDispatch} from 'react-redux';
import {useNavigate} from 'extensions/navigation';
import {useToast} from 'react-native-toast-notifications';
import {useModal} from 'extensions/viewport/useModal';
import {Prompt} from 'interface/base/Prompt';
import {purge, loadTrash} from 'utils/mediafire';

export function useModalPurge(ids: string[]) {
  const {t} = useLingui();
  const modal = useModal();
  const toast = useToast();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const submit = useCallback(async () => {
    const res = await purge(dispatch, ids);
    loadTrash(navigate, dispatch, true);
    if (res[0] || res[1]) {
      toast.show(t`Deleted items from trash`);
    } else {
      toast.show(res?.message ?? t`Failed to purge items`, {type: 'danger'});
    }
    modal.exit();
  }, [ids]);

  const open = useCallback(() => {
    modal.open(
      <Prompt
        title={t`Delete items`}
        text={t`This will permanently delete the items you have selected. They will no longer be able to be restored, and this cannot be undone. Would you like to continue?`}
        buttons={[
          {
            mode: 'destructive',
            text: t`Yes, delete`.toUpperCase(),
            onPress: submit,
          },
          {
            mode: 'cancel',
            text: t`Cancel`.toUpperCase(),
            onPress: modal.exit,
          },
        ]}
      />
    );
  }, [ids]);

  return {open, exit: modal.exit};
}
